export default "__VITE_ASSET__587bd8de__"